import { colors } from '@vizit/theme';
import type { IconProps } from './types';

export const ClockRewindIcon = (props: IconProps) => {
  const { stroke = colors['gray-utility'][500], size = 15, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M17.4166 9.75L15.7505 8.08333L14.0833 9.75M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C11.2516 1 13.6571 2.48178 14.9621 4.69091M8.5 4.33333V8.5L11 10.1667"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
